let resizer = (selector) => {
    let maxHeight = 0;

    $(selector).each(function () {
        if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        }
    });

    $(selector).height(maxHeight);
};

export default resizer;
